/**
 * The notice members accept before using the Commercial Hub.
 *
 * The version and the wording live in the same file on purpose. Editing the text
 * without bumping the version silently invalidates every stored acceptance —
 * you'd still have records, but you could no longer say what any of them agreed
 * to. Keeping them adjacent makes that mistake hard to make by accident.
 *
 * Bump CONSENT_VERSION whenever the meaning changes (not for typos), and everyone
 * is asked again on their next visit.
 */
export const CONSENT_VERSION = '2026-08-26';
export const CONSENT_TITLE = 'Before you start';
/**
 * Plain language, deliberately. A wall of legalese is read by nobody, which makes
 * it worse than useless as disclosure — the point is that people actually know.
 */
export const CONSENT_BODY = [
    'Agents Alliance staff can see what you do in the Commercial Hub — the submissions you build, the documents you upload, and the accounts you work on.',
    'We use that to help you place business, to sort things out when something goes wrong, and to train our own team so the service gets better.',
    'Documents you upload often contain sensitive information about your clients, including things like Social Security and tax ID numbers. Please upload only what the work actually needs.',
    'We do not sell your data. We share it outside Agents Alliance only with carriers and markets, as part of placing the business you have asked us to place.',
];
export const CONSENT_ACCEPT_LABEL = 'I understand — continue';
